export const environment = {
    production: false,
    apiBaseUrl: 'https://template.backend.stage.gravityigm-dev.com/api/v1',
    auth0: {
        domain: "cleargov-auth.us.auth0.com",
        clientId: "nd0HIJnYO8LfUIJUS3z8zoiSVGMdDOxJ",
        audience: "https://cleargov-auth.us.auth0.com/api/v2/",
        redirectUri: "https://admin.template.stage.gravityigm-dev.com"
    },
};
